export default __webpack_public_path__ + "static/media/video-cover.1aa463f8.jpg";